import { LOCKABLE_PAGE_ROOT_SELECTOR } from '@front-app/constants/scrollLock';
import { onUnmounted, ref, watch } from '@vue/composition-api';

export interface UseScrollLock {
	register(): void;
	unregister(): void;
}

export const useScrollLock = (elSelector: string): UseScrollLock => {
	const locks = ref(0);
	const register = () => {
		locks.value += 1;
	};
	const unregister = () => {
		locks.value = Math.max(locks.value - 1, 0);
	};
	watch(locks, (curr, prev) => {
		if (prev === 0 && curr > 0) {
			doLock(elSelector);
		} else if (curr === 0 && prev > 0) {
			doUnlock(elSelector);
		}
	});
	return {
		register,
		unregister,
	};
};

// Based on https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
function doLock(elSelector: string) {
	const el = document.querySelector(elSelector) as HTMLElement | undefined;
	if (!el) {
		return;
	}
	el.style.overflow = 'hidden';
}

// Based on https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
function doUnlock(elSelector: string) {
	const el = document.querySelector(elSelector) as HTMLElement | undefined;
	if (!el) {
		return;
	}
	el.style.overflow = '';
}

const appScrollLock = useScrollLock(LOCKABLE_PAGE_ROOT_SELECTOR);

export const useAppScrollLock = (): UseScrollLock => {
	let isRegistered = false;
	onUnmounted(() => {
		if (isRegistered) {
			appScrollLock.unregister();
			isRegistered = false;
		}
	});
	return {
		register() {
			if (!isRegistered) {
				appScrollLock.register();
			}
			isRegistered = true;
		},
		unregister() {
			if (isRegistered) {
				appScrollLock.unregister();
			}
			isRegistered = false;
		},
	};
};
